import { createActionGroup } from '@ngrx/store';
import {
  zefActionFailPayload,
  zefActionPayload,
  zefActionSuccessPayload
} from '@zerops/zef/core';
import { UserTokenListResponse } from './user-token-base.model';
import { FEATURE_NAME } from './user-token-base.constant';

export const userTokenActions = createActionGroup({
  source: FEATURE_NAME,
  events: {
    'Load Tokens': zefActionPayload<void>(),
    'Load Tokens Success': zefActionSuccessPayload<UserTokenListResponse>(),
    'Load Tokens Fail': zefActionFailPayload
  }
});
